import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { AngularFireAuth } from 'angularfire2/auth';
import { FirebaseObjectObservable } from 'angularfire2/database';
import { User as FirebaseUser } from 'firebase';
import { Subscription } from 'rxjs/Subscription';

import { User } from './models/user';

import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  user$?: FirebaseObjectObservable<User | null>;
  authSubscription?: Subscription;

  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.authSubscription = this.afAuth.authState
      .subscribe((firebaseUser: FirebaseUser | null) => {
        if (firebaseUser) {
          this.user$ = this.userService.getUser(firebaseUser.uid);
        } else {
          this.user$ = undefined;
        }
      });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  onClickLogOut() {
    this.afAuth.auth.signOut();
    this.router.navigateByUrl('/login');
  }

  onResetPassword() {
    const user = this.afAuth.auth.currentUser;
    if (user != null) {
      const userEmail = user.email;
      if (userEmail) {
        this.afAuth.auth.sendPasswordResetEmail(userEmail).then(function() {
          alert('Password Reset Email Sent')
        }).catch(function(error) {
          alert(`Error Encountered: ${error}`)
        });
      } else {
        alert('User is not signed in.')
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/app.component.ts